export default __webpack_public_path__ + "static/media/play-video.ea1c2471.svg";